import {
  SHOW_COMPARE, ADD_COMPARE, REMOVE_COMPARE, CLEAN_COMPARE,
} from '../actions/compare';

export const initialState = {
  compare: [],
};

const compareReducer = function (state = initialState, action) {
  switch (action.type) {
    case SHOW_COMPARE:
      return {
        ...state,
        compare: action.payload.sort((a, b) => a.id - b.id),
      };

    case ADD_COMPARE:
      return {
        ...state,
        compare: [
          ...state.compare,
          action.payload,
        ].sort((a, b) => a.id - b.id),
      };

    case REMOVE_COMPARE:
      return {
        ...state,
        compare: [
          ...state.compare.filter((item) => item.insuranceCompanyCode !== action.payload.id).concat(...state.compare.filter((item) => item.insuranceCompanyCode === action.payload.id).filter((el) => el.tarif.name !== action.payload.tarif.name)),
        ].sort((a, b) => a.id - b.id),
      };

    case CLEAN_COMPARE:
      return {
        ...state,
        compare: [],
      };

    default:
      return state;
  }
};

export default compareReducer;
